export default __webpack_public_path__ + "static/virtual_1-986482fa4e0fc1cbaf028122524c8ffa.png";